import Vue from "vue";
import Router from "vue-router";
import routes from "../router/index";
import { store } from '../_store/index.js';
import swal from "sweetalert2";
import firebase from "firebase";
var firstuid = JSON.parse(localStorage.getItem("user"));
Vue.use(Router);

export const router = new Router({
  mode: "hash",
  routes: routes,
  // scrollBehavior(to, from, savedPosition) {
  //   const container = document.querySelector(".main-panel");
  //   container.scrollTop = 0;
  //   return { x: 0, y: 0 }
  // }
});
router.beforeEach((to, from, next) => {
  const publicPages = ['/LoginPage',];
  let user = JSON.parse(localStorage.getItem("data"));

  const authRequired = !publicPages.includes(to.path);
  const isAuthenticated = firebase.auth().currentUser;
  const accessArray = ['tournaments',
    'paidTournament', 'freeTournament', 'tournamentPractice', 'editFreeTournament', "editTournamentV2", "tournamentLeaderboard"]
  // console.log("!accessArray.includes(to.fullPath)", accessArray.includes(to.name));
  // if (user?.userRole == 'user' && !accessArray.includes(to.name)) {
  //   // console.log("path", to.name);
  //   return next('/tournaments')
  // }
  if (authRequired && !isAuthenticated) {
    return next('/LoginPage')
  }
  if (!authRequired && isAuthenticated) {
    // return next('/dashboard')
    return next('/tournaments')

  }
  next()
});
// router.beforeEach((to, from, next) => {
//   const publicPages = ["/LoginPage", "/registerpage",];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = JSON.parse(localStorage.getItem("user"));
//   if (to.path.includes('/logout')) {
//     swal({
//       title: "Are you sure?",
//       type: "warning",
//       showCancelButton: true,
//       confirmButtonClass: "md-button md-success",
//       cancelButtonClass: "md-button md-danger",
//       confirmButtonText: "Logout",
//       buttonsStyling: false
//     }).then(result => {
//       if (result.value) {
//         const { dispatch } = store;
//         dispatch("authentication/logout", "", { root: true });
//         document.documentElement.style.overflow = "auto";
//         return next()
//       }
//       else {
//         document.documentElement.style.overflow = "auto";
//         return next(from.path)
//       }
//     })

//   }

//   if (to.path.includes('/reLogin')) {
//     const { dispatch } = store;
//     dispatch("authentication/logout", "", { root: true });
//     return next("/LoginPage");
//   }

//   if (!firstuid) {
//     firstuid = loggedIn
//   }
//   if (loggedIn && firstuid.id != loggedIn.id) {
//     window.location.reload()
//   }
//   if (to.path.includes('/verifyaccount')) {
//     if (loggedIn) {
//       const { dispatch } = store;
//       dispatch("authentication/logout", "", { root: true });
//       return next(to.path)
//     }
//     else {
//       return next()
//     }
//   }
//   if (to.path.includes('/reset')) {
//     return next()
//   }
//   if (to.path.includes('/propertyDetailsView')) {
//     return next()
//   }
//   if (to.path.includes('/verifychangedaccount')) {
//     return next()
//   }
//   if (to.path.includes('/registerpage')) {
//     return next()
//   }
//   if (to.path.includes('/reLogin')) {
//     const { dispatch } = store;
//     dispatch("authentication/logout", "", { root: true });
//     return next("/Login");
//   }
//   if (authRequired && !loggedIn) {
//     // return next("Login");
//     return next("/LoginPage");
//   }

//   if (!authRequired && loggedIn) {
//     return next("/dashboard");
//   }

//   next();
// });